/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../lib/@waca/dashboard-common/dist/core/Collection',
	'./FilterValue',
	'underscore'
], function( Collection, FilterValue, _) {
	'use strict';

	/**
	 * A collection of values used by a filter. For example the filter:
	 *
	 * country in ('Canada', 'USA')
	 *
	 * The filter values collection would be 'Canada' and 'USA'
	 */
	var FilterValuesCollection = null;
	FilterValuesCollection = Collection.extend({

		// The class of objects that this collection manages
		modelClass: FilterValue,

		init: function(/* models, options */) {
			FilterValuesCollection.inherited('init', this, arguments);
		},

		/**
		 * @return the filter values entry that corresponds to the filter values object or ID.
		 *			NOTE: null is a valid value for the filter values collection.
		 */
		get: function( objOrId ) {
			return this.modelMap[objOrId] || ((objOrId && objOrId.id!==undefined) ? this.modelMap[objOrId.id] : undefined);
		},

		/**
		 * @returns the filterValues collection as a simple array of strings ['v1','v2','v3']
		 */
		toArray: function() {
			var returnValues=[];
			_.each(this.models, function(model) {
				returnValues.push(model.value);
			});
			return returnValues;
		},

		/**
		 * Each entry in the filterValues collection is a string value or a nested filterEntry object.
		 * Process each entry calling toJSON on each.
		 * @returns the filterValues collection in JSON form (which is a simple array of strings)
		 */
		toJSON: function() {
			var returnValues=[];
			_.each(this.models, function(model) {
				if (model.value && model.value.toJSON) {
					returnValues.push(model.value.toJSON());
				} else {
					returnValues.push(model.value);
				}
			});
			return returnValues;
		}

	});

	return FilterValuesCollection;
});
